import type { ApiClient } from '../../api/client';
import type { AdministratorPort } from '../../features/security/public';

export function createAdministratorHttpAdapter(client: ApiClient): AdministratorPort {
  return {
    async load(canReadStaffing) {
      const [bindings, options, organizations] = await Promise.all([
        client.listAdministrators(),
        client.getAdministratorOptions(),
        canReadStaffing ? client.listAllSupervisoryOrganizations() : Promise.resolve({ data: [], total: 0 }),
      ]);
      return {
        bindings: bindings.data,
        options,
        organizations: organizations.data.map((organization) => ({
          id: organization.id,
          name: organization.descriptor || organization.organizationCode || '이름 미등록',
        })),
      };
    },
    create(input) {
      return client.createAdministrator(input);
    },
    update(id, input) {
      return client.updateAdministrator(id, input);
    },
    async revoke(id) {
      await client.revokeAdministrator(id);
    },
    createRole(input) {
      return client.createAdministratorRole(input);
    },
    updateRole(roleCode, input) {
      return client.updateAdministratorRole(roleCode, input);
    },
  };
}
